import { useMatch } from "react-router-dom";
import DocsBotWidget from "./DocsBotWidget";
import { docsBotAI } from "../../Variables";
import { useContext } from "react";
import { GlobalCtx } from "../../context/GlobalContext";

const ChatHost = () => {
  const { lang } = useContext(GlobalCtx);
  const onLangRoot = !!useMatch({ path: "/", end: true });
  const id = docsBotAI(lang);

  return (
    <DocsBotWidget
      id={id}
      lang={lang}
      reloadKey={lang}
      enabled={onLangRoot}
      options={{}}
      metadata={{}}
    />
  );
};

export default ChatHost;
